import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/stores/authStore'
import { appConfig } from '@/types/appConfig.type'

import LoginView from "@/views/LoginView.vue"
import CaptureView from '@/views/CaptureView.vue';

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: {
      requiresAuth: false,
      layout: null,
    }
  },
  {
    path: '/',
    name: 'Capture',
    component: CaptureView,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(appConfig.BASE_URL),
  routes
})

router.beforeEach((to, _, next) => {
  const authStore = useAuthStore()
  
  if (to.meta.requiresAuth && !authStore.authenticated) {
    return next({
      path: '/login',
    })
  }

  next()
})

export function getRoutes(): RouteRecordRaw[] {
  return routes;
}

export default router
